import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthUser } from '../../../models/user';
import { AuthService } from '../../../auth/auth.service';
import { MatFormField } from '@angular/material/form-field';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { BlockScrollStrategy } from '@angular/cdk/overlay';
import { FormButton } from 'src/app/components/form-button/form-button.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('visible', style({
        opacity: 1,
        display: 'block'
      })),
      state('hidden', style({
        opacity: 0,
        display: 'none'
      })),
      transition('visible=>hidden', animate('200ms')),
      transition('hidden=>visible', animate('200ms'))
    ]),
  ]
})
export class LoginComponent implements OnInit {
  hide = true;
  loginForm: FormGroup;
  resetForm: FormGroup;
  isSubmitted = false;
  loginButton: FormButton = new FormButton('Log in', null);
  resetPasswordButton: FormButton = new FormButton('Reset Password');
  loginState = 'visible';
  resetState = 'hidden';

  constructor(private authService: AuthService, private router: Router, private formBuilder: FormBuilder) {
    // Initialize forms in constructor
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.resetForm = this.formBuilder.group({
      email: ['', Validators.required]
    });
  }

  async ngOnInit() {
    if (await this.authService.isLoggedIn()) {
      this.router.navigateByUrl('/Home');
    }
  }

  setReset() {
    this.loginState = this.loginState === 'visible' ? 'hidden' : 'visible';
    this.resetState = this.resetState === 'visible' ? 'hidden' : 'visible';
  }

  resetPasswordSubmit() {
    this.resetPasswordButton.setSubmit('Loading..');
    this.authService
      .userRequestPasswordReset(this.resetForm.value.email)
      .then(() => {
        this.resetPasswordButton.setSuccess('Reset password email sent');
      })
      .catch((errResponse) => {
        this.resetPasswordButton.setError(errResponse.error.error, errResponse.error.message);
      });
  }

  get formControls() { return this.loginForm.controls; }

  async login() {
    this.loginButton.setSubmit('submitting');
    const response = this.authService.userLogin(this.loginForm.value);
    response.then((val) => {
      this.loginButton.setSuccess('Success!');
      this.router.navigateByUrl('/Home');
    }).catch((response: string) => {
      if (response == 'Bad credentials') {
        this.loginButton.setError('Incorrect username or password', '');
      } else {
        this.loginButton.setError(response, '');
      }
    });
  }
}
